var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('WidgetCard',{attrs:{"title":_vm.$t('performance_graph_widget_title'),"loading":_vm.isLoading,"sheet-class":_vm.sheetClass}},[_c('ChartPerformanceIndex',{attrs:{"player-id":_vm.playerId},on:{"loaded":_vm.setLoaded}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }